import { render, staticRenderFns } from "./SHFY.vue?vue&type=template&id=fde2b90c&scoped=true&"
import script from "./SHFY.vue?vue&type=script&lang=js&"
export * from "./SHFY.vue?vue&type=script&lang=js&"
import style0 from "./SHFY.vue?vue&type=style&index=0&id=fde2b90c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde2b90c",
  null
  
)

export default component.exports